module.exports = __webpack_public_path__ + "img/pointer_active.fa150c03.png";